import { sub } from 'date-fns';
import { defineMessages } from 'react-intl';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

export enum Timeframe {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  THREE_MONTHS = 'THREE_MONTHS',
  SIX_MONTHS = 'SIX_MONTHS',
  YEAR = 'YEAR',
}

const NOW = new Date();

const ONE_WEEK_AGO = sub(NOW, { weeks: 1 });
const ONE_MONTH_AGO = sub(NOW, { months: 1 });
const THREE_MONTHS_AGO = sub(NOW, { months: 3 });
const SIX_MONTHS_AGO = sub(NOW, { months: 6 });
const ONE_YEAR_AGO = sub(NOW, { years: 1 });

export const TIME_FRAME_FROM_TO: Record<Timeframe, { from: Date; to: Date }> = {
  [Timeframe.WEEK]: {
    from: ONE_WEEK_AGO,
    to: NOW,
  },
  [Timeframe.MONTH]: {
    from: ONE_MONTH_AGO,
    to: NOW,
  },
  [Timeframe.THREE_MONTHS]: {
    from: THREE_MONTHS_AGO,
    to: NOW,
  },
  [Timeframe.SIX_MONTHS]: {
    from: SIX_MONTHS_AGO,
    to: NOW,
  },
  [Timeframe.YEAR]: {
    from: ONE_YEAR_AGO,
    to: NOW,
  },
};
export const AVAILABLE_TIMEFRAMES: Timeframe[] = Object.values(Timeframe);

export const timeframeMessages = defineMessages<Timeframe>({
  [Timeframe.WEEK]: {
    defaultMessage: '1 Week',
  },
  [Timeframe.MONTH]: {
    defaultMessage: '1 Month',
  },
  [Timeframe.THREE_MONTHS]: {
    defaultMessage: '3 Months',
  },
  [Timeframe.SIX_MONTHS]: {
    defaultMessage: '6 Months',
  },
  [Timeframe.YEAR]: {
    defaultMessage: '1 Year',
  },
});
export const getTimeframeFromRarity = (rarity: Rarity) => {
  switch (rarity) {
    case Rarity.unique:
      return Timeframe.YEAR;
    case Rarity.super_rare:
      return Timeframe.SIX_MONTHS;
    case Rarity.rare:
      return Timeframe.THREE_MONTHS;
    case Rarity.limited:
    default:
      return Timeframe.WEEK;
  }
};
